import { ConstantValues } from './util/constantValues';
import { PageType } from './enums';

/* eslint-disable eqeqeq */
export class QueryParams {
  public userName: string;
  public userToken: string;
  public userCurrency: string;
  // public userLanguage: string;
  public eventId: number;
  public competitionId: number = null;
  public sportId: number = null;
  public sportStartingSoonId: number = null;
  public regionId: number = null;
  public ticketId: string = null;
  public ticketPin: string = null;

  constructor(queryParameters: { [key: string]: any }) {
    this.userName = queryParameters.username ? queryParameters.username : null;
    this.userToken = queryParameters.token ? queryParameters.token : null;
    this.userCurrency = queryParameters.currency ? queryParameters.currency : null;
    // this.userLanguage = queryParameters.language ? queryParameters.language : null;
    this.eventId = !isNaN(Number(queryParameters.eventId)) ? Number(queryParameters.eventId) : null;
    if (!isNaN(Number(queryParameters.event))) {
      this.eventId = Number(queryParameters.event);
    }
    this.sportStartingSoonId = !isNaN(Number(queryParameters.sportStartingSoonId)) ? Number(queryParameters.sportStartingSoonId) : null;
    const ids: string = queryParameters.competitionId ? queryParameters.competitionId : null;
    if (ids) {
      const tmpIds: string[] = ids.split('-');
      if (ids.startsWith('-')) {
        this.sportId = tmpIds[1] ? !isNaN(Number(tmpIds[0])) ? -1 * Number(tmpIds[1]) : null : null;
        this.regionId = tmpIds[2] ? !isNaN(Number(tmpIds[1])) ? Number(tmpIds[2]) : null : null;
        this.competitionId = tmpIds[3] ? !isNaN(Number(tmpIds[2])) ? Number(tmpIds[3]) : null : null;
      } else {
        this.sportId = tmpIds[0] ? !isNaN(Number(tmpIds[0])) ? Number(tmpIds[0]) : null : null;
        this.regionId = tmpIds[1] ? !isNaN(Number(tmpIds[1])) ? Number(tmpIds[1]) : null : null;
        this.competitionId = tmpIds[2] ? !isNaN(Number(tmpIds[2])) ? Number(tmpIds[2]) : null : null;
      }
    }

    const ticketIds: string = queryParameters.ticket ? queryParameters.ticket : null;
    if (ticketIds && !isNaN(+ticketIds) && ticketIds.length >= ConstantValues.MIN_TICKET_ID_SIZE + ConstantValues.TICKET_PIN_SIZE && ticketIds.length <= ConstantValues.MAX_TICKET_ID_SIZE + ConstantValues.TICKET_PIN_SIZE) {
      this.ticketPin = ticketIds.slice(-1 * ConstantValues.TICKET_PIN_SIZE);
      this.ticketId = ticketIds.slice(0, -1 * ConstantValues.TICKET_PIN_SIZE);

    }
  }
}
